import { render } from "./BlockSelector.vue?vue&type=template&id=489f2bb4&scoped=true"
import script from "./BlockSelector.vue?vue&type=script&lang=js"
export * from "./BlockSelector.vue?vue&type=script&lang=js"

import "./BlockSelector.vue?vue&type=style&index=0&id=489f2bb4&lang=css"
import "./BlockSelector.vue?vue&type=style&index=1&id=489f2bb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489f2bb4"]])

export default __exports__